/* eslint-disable prettier/prettier */
/* eslint-disable no-undef */
import api from "./ApiService";

const getInvestorsList = (data: any) => {
  return api
    .get<any>(process.env.REACT_APP_API_BASE_URL + `/investors?${data}`)
    .then((response: any) => {
      return response;
    });
};

const exportInvestorsList = (data: any) => {
  return api
    .get<any>(process.env.REACT_APP_API_BASE_URL + `/investors/export?${data}`)
    .then((response: any) => {
      return response;
    });
};

const updateInvestorsList = (data: any) => {
  return api
    .put<any>(process.env.REACT_APP_API_BASE_URL + `/investors`, data)
    .then((response: any) => {
      return response;
    });
};

const updateInvestorsPackageList = (data: any) => {
  return api
    .put<any>(
      process.env.REACT_APP_API_BASE_URL + `/investor-package-configurations`,
      data,
    )
    .then((response: any) => {
      return response;
    });
};

const createInvestorsPackageList = (data: any) => {
  return api
    .post<any>(
      process.env.REACT_APP_API_BASE_URL + `/investor-package-configurations`,
      data,
    )
    .then((response: any) => {
      return response;
    });
};

const getInvestorsPackage = (id: any) => {
  return api
    .get<any>(
      process.env.REACT_APP_API_BASE_URL +
        `/investor-package-configurations?InvestorId=${id}`,
    )
    .then((response: any) => {
      return response;
    });
};

const updateInvestorsPackage = (data: object) => {
  return api
    .put<any>(
      process.env.REACT_APP_API_BASE_URL + `/investor-package-configurations`,
      data,
    )
    .then((response: any) => {
      return response;
    });
};

const getInvestorsListByID = (investorId: number) => {
  return api
    .get<any>(process.env.REACT_APP_API_BASE_URL + `/investors/${investorId}`)
    .then((response: any) => {
      return response;
    });
};

const InvestorService = {
  getInvestorsList,
  updateInvestorsList,
  getInvestorsPackage,
  updateInvestorsPackageList,
  updateInvestorsPackage,
  createInvestorsPackageList,
  getInvestorsListByID,
  exportInvestorsList
};
export default InvestorService;
